const reportNavigationButtonMixin = {
  methods: {
    navigateTo(nameOfPath, currentReportId) {
      this.$router.push( { name: nameOfPath, params: { id: currentReportId } })
    }
  },
}

export default reportNavigationButtonMixin
